module.exports = __webpack_public_path__ + "img/ennetix-users-page-maintenance-tab2.8dae0b16.png";